import { Box, Grid2, Paper, Typography, useTheme } from '@mui/material';
import { FC, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Input } from '../../../Components/Form/Input/input.component';
import { InputCurrency } from '../../../Components/Form/InputCurrency/input-currency.component';
import InputMaskComponent from '../../../Components/Form/InputMask/input-mask.component';
import RichTextEditor from '../../../Components/Form/RichTextEditor/rich-text-editor.component';
import { Switch } from '../../../Components/Form/Switch/switch.component';


import { Loader } from '../../../Components/Loader';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';


import { useDetailsStocks } from './details-stocks-hook';

import { Can } from '../../../Components/Can';

import { ListMangerStocksUseCase } from '../../../Usecase/Stocks/list-manager-stocks-usecase';
import { ShowProductUseCase } from '../../../Usecase/Products/show-product-usecase';
import InputCalendar from '../../../Components/Form/InputCalendar/input-calendar.component';
import { ShowStocksByProductUseCase } from '../../../Usecase/Stocks/show-stocks-by-product-usecase';
import { Table } from '../../../Components/Table/table.component';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { Tag } from '@chakra-ui/react';
import { FaEye, FaTrash } from 'react-icons/fa';
import { MdAttachMoney } from 'react-icons/md';
import { ButtonActionMenu } from '../../../Components/Form/ButtonActionsMenu/button-action-menu.component';
import { normalizeFinancialStatusTitle, normalizeSFinancialStatusColors } from '../../../utils/normalizeFinancialStatus';
import { Select } from '../../../Components/Form/Select';
import { SelectComponent } from '../../../Components/Form/Select/select.component';
import { EStockNameEnum } from "../../../Services/api/stocks/stocks.interface";
import console from 'console';
import { GoPlus } from 'react-icons/go';
import { ConfirmDialog } from '../../../Components/Dialog/variants/dialog-confirmation/dialog-confirmation.component';
import { DestroyStocksUseCase } from '../../../Usecase/Stocks/destroy-stocks-usecase';



  interface IStocksDetailsProps {
    listMangerStocksUseCase: ListMangerStocksUseCase
    showProductUseCase: ShowProductUseCase
    showStocksByProductUseCase: ShowStocksByProductUseCase
    destroyStocksUseCase: DestroyStocksUseCase
  }
const StocksDetails : FC<IStocksDetailsProps> = ({ listMangerStocksUseCase, showProductUseCase, showStocksByProductUseCase, destroyStocksUseCase }) => {
   
    const theme = useTheme()
    const navigate = useNavigate()
   

    const { control, errors, handleAction, handleSubmit, loading, register, data, setStartDate, setEndDate, handleShowMovimentation, stocks, stockNameOptions, stockName, setStockName, product, setMovimentationToDelete, movimentationToDelete, handleDestroyMovimentation} = useDetailsStocks({
      listMangerStocksUseCase,
      showProductUseCase,
        showStocksByProductUseCase,
      destroyStocksUseCase
    })

    const columns = useMemo(() => {
      const createColumns: any[] = [ 
      
        {
          field: 'createdAt',
          headerName: 'Data',
          flex: 1,
          renderCell: (params: any) => {
            const date = new Date(params?.row?.createdAt);
            const formattedDate = date.toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            });
            return <Box sx={{height: '100%', display: 'flex', alignItems: 'center'}}><Typography>{formattedDate}</Typography></Box>
          }
        },
        {
          field: 'action',
          headerName: 'Ação',
          flex: 1,
          renderCell: (params: any) => <Box sx={{height: '100%', display: 'flex', alignItems: 'center'}}>
            {params?.row?.action === "ADD" && <Typography sx={{ color: 'success.main' }}>Entrada</Typography>}
            {params?.row?.action === "REMOVE" && <Typography sx={{ color: 'error.main' }}>Saída</Typography>}
            {params?.row?.action === "ADJUST" && <Typography sx={{ color: 'warning.main' }}>Ajuste Interno no HUB</Typography>}
           
          </Box>
        },
        {
          field: 'omieStock',
          headerName: 'Estoque',
          flex: 1,
          renderCell: (params: any) => <Box sx={{height: '100%', display: 'flex', alignItems: 'center'}}><Typography >{`${params?.row?.omieStock}`}</Typography></Box>
        },
        {
          field: 'howMany',
          headerName: 'Quantidade',
          flex: 1,
          renderCell: (params: any) => {
            return <Box sx={{height: '100%', display: 'flex', alignItems: 'center'}}><Typography >{`${params?.row?.howMany}`}</Typography></Box>
          } 
        },
        {
          field: "actions",
          headerName: "Ações",
           renderCell: (params: any) => <ButtonActionMenu options={[
            {
              title: 'Excluir Movimentação',
              onClick: () => setMovimentationToDelete(params.row),
              titleColor: 'error.main',
              icon: <FaTrash size={18} />
            }
          ]} />
        }
        
      ];
    
      return createColumns;
    }, [stocks]);




    return (
      <Can permissions={['menu:stocks:manage']}>
        <BaseScreen>
        <ConfirmDialog title='Remover Movimentação' onCancel={() => setMovimentationToDelete(undefined)} description='Você tem certeza?' open={!!movimentationToDelete} onConfirm={handleDestroyMovimentation}  /> 
          <Paper>
            <BaseContentPage 
              title={`Estoque Produto: ${product?.name}`}
              breadcrumb={[{ title: 'Estoque', link: "/stocks-list"}, { title: 'Novo Produto'}]}
              Action={() => <Button LeftIcon={() => <GoPlus size={18} />} sx={{ width: '230px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() => navigate(`/stocks-form/${product?.id}`)}>Adicionar Movimentação</Button>}
            >
              {loading && <Loader />}

                
                  <Grid2 container spacing={5} sx={{ marginTop: 2}} component="form" onSubmit={handleSubmit(handleAction)}>
     

                    <Grid2 size={12}>
                      <Grid2 container spacing={3}>
                        <Grid2 size={4}>
                          <Paper sx={{ p: 3, textAlign: 'center' }}>
                            <Typography variant="h6" color="text.secondary" gutterBottom>
                              Empenho
                            </Typography>
                            <Typography variant="h4" component="div">
                              {data?.allocatedStockQuantity || 0}
                            </Typography>
                          </Paper>
                        </Grid2>
                        <Grid2 size={4}>
                          <Paper sx={{ p: 3, textAlign: 'center' }}>
                            <Typography variant="h6" color="text.secondary" gutterBottom>
                              Produção
                            </Typography>
                            <Typography variant="h4" component="div">
                              {data?.workInProgressQuantity || 0}
                            </Typography>
                          </Paper>
                        </Grid2>
                        <Grid2 size={4}>
                          <Paper sx={{ p: 3, textAlign: 'center' }}>
                            <Typography variant="h6" color="text.secondary" gutterBottom>
                              Acabado
                            </Typography>
                            <Typography variant="h4" component="div">
                              {data?.finishedGoodsQuantity || 0}
                            </Typography>
                          </Paper>
                        </Grid2>
                      </Grid2>
                    </Grid2>
            

                    <Grid2 size={12}>
                      <Typography sx={{marginBottom: '10px', fontSize: '19px', fontWeight: '600'}}>Movimentações:</Typography>
                    </Grid2>

                    <Grid2 size={3}>
                      <InputCalendar onSubmit={() => {}} onChange={(e: any) => setStartDate(e)} />
                    </Grid2>

                    <Grid2 size={3}>
                      <InputCalendar onSubmit={() => {}} onChange={(e: any) => setEndDate(e)} />
                    </Grid2>

                    <Grid2 size={3}>
                      <SelectComponent
                        options={stockNameOptions}
                        label=""
                        name="stockName"
                        control={control}
                        placeholder="Selecione o tipo de estoque"
                        onChangeCallback={(value) => setStockName(value as EStockNameEnum)}
                      />
                    </Grid2>

                    <Grid2 size={3}>
                      <Button type="submit" sx={{ marginTop: '10px', width: '200px' }} isLoading={loading} onClick={handleShowMovimentation}>
                        Consultar
                      </Button>
                    </Grid2>

                    <Grid2 size={12}>
                    {!!stocks?.length ?  <Table data={stocks} columns={columns} totalCount={0} checkboxSelection={false} /> : <Placeholder description='Nenhum dado encontrado.' /> }

                  
                    </Grid2>

               
                  </Grid2>
                
              
            </BaseContentPage>
          </Paper>
        </BaseScreen>
      </Can>
    );
  }
  
  export { StocksDetails };
